// @flow

import type { PropsSchema, BasicProps, JsEnv } from '../../type'
import * as React from 'react'
import computeData from '../hoc/computeData'

type Props = BasicProps & {
  url: string,
  jsEnv: JsEnv,
  style: { [string]: string }
};

@computeData({ includeData: true })
export default class Iframe extends React.PureComponent<Props> {
  static schema: PropsSchema = [
    {
      type: 'style'
    },
    'separator',
    {
      key: 'url',
      type: 'text',
      title: 'URL'
    }
  ];
  render () {
    const { url, style, jsEnv } = this.props
    const jsEnvUrl = jsEnv.getString(url)
    let newUrl = /^(http|https):\/\//.test(jsEnvUrl)
      ? jsEnvUrl
      : `${window.location.origin}${jsEnvUrl}`
    return (
      <div style={{ height: '100%' }}>
        <iframe title='iframe' src={newUrl} frameBorder='0' style={style} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/basic/Iframe.js